var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-inner app-main-page push-config" },
    [
      _c("div", { staticClass: "app-main-inner-row" }, [
        _c(
          "div",
          { staticClass: "filters" },
          [
            _c(
              "el-form",
              {
                attrs: {
                  inline: true,
                  "label-width": "100px",
                  "label-position": "right"
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "el-form-item-wrapper" },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          "label-width": "100px",
                          label: _vm.$t("SystemMaintenance.SelectBranch")
                        }
                      },
                      [
                        _c(
                          "el-select",
                          {
                            on: { change: _vm.getRemarkConfigFunc },
                            model: {
                              value: _vm.branchId,
                              callback: function($$v) {
                                _vm.branchId = $$v
                              },
                              expression: "branchId"
                            }
                          },
                          _vm._l(_vm.currentOfficeList, function(office) {
                            return _c("el-option", {
                              key: office.uuid,
                              attrs: {
                                value: office.officeId,
                                label: office.code
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            )
          ],
          1
        )
      ]),
      _c("div", { staticClass: "app-el-transfer_page" }, [
        _c("div", { attrs: { align: "center" } }, [
          _c("ul", [
            _c("li", [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Precautions")))]),
            _c("li"),
            _c("li", [
              _vm._v(
                _vm._s(_vm.$t("SystemMaintenance.SavedEffectFromTheInvoice"))
              )
            ]),
            _c("li", [
              _vm._v(_vm._s(_vm.$t("SystemMaintenance.EBeLessThanCharacters")))
            ]),
            _c("li", [
              _vm._v(
                _vm._s(_vm.$t("SystemMaintenance.PaperBeLessThanCharacters"))
              )
            ]),
            _c("li", [
              _vm._v(
                _vm._s(_vm.$t("SystemMaintenance.AutomaticallyALineDoesShow"))
              )
            ]),
            _c("li", [
              _vm._v(_vm._s(_vm.$t("SystemMaintenance.PDFCanDisplayUpLines")))
            ])
          ])
        ]),
        _c(
          "div",
          {
            staticClass: "app-el-transfer",
            staticStyle: { width: "100%", display: "flex" }
          },
          [
            _c("el-transfer", {
              ref: "transfer",
              staticStyle: { width: "700px" },
              attrs: {
                id: "transfer",
                "target-order": "push",
                data: _vm.listData,
                titles: [
                  _vm.$t("SystemMaintenance.Unused"),
                  _vm.$t("SystemMaintenance.Used")
                ]
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(ref) {
                    var option = ref.option
                    return _c(
                      "span",
                      {
                        attrs: { draggable: !option.disabled },
                        on: {
                          dragstart: function($event) {
                            return _vm.drag($event, option)
                          }
                        }
                      },
                      [
                        option.key == 18
                          ? _c(
                              "label",
                              {
                                staticClass: "app-el-transfer-label",
                                attrs: {
                                  title: _vm.$t(
                                    "SystemMaintenance.Example8180ThisTicketOnlyDollars"
                                  )
                                }
                              },
                              [
                                _vm._v(" " + _vm._s(option.label) + " "),
                                _c("img", {
                                  attrs: {
                                    src: "/static/q.png",
                                    width: "12",
                                    height: "12"
                                  }
                                })
                              ]
                            )
                          : _c(
                              "label",
                              { staticClass: "app-el-transfer-label" },
                              [_vm._v(" " + _vm._s(option.label) + " ")]
                            )
                      ]
                    )
                  }
                }
              ]),
              model: {
                value: _vm.transferValue,
                callback: function($$v) {
                  _vm.transferValue = $$v
                },
                expression: "transferValue"
              }
            }),
            _c(
              "div",
              { staticClass: "custom-remarks", staticStyle: { flex: "1" } },
              [
                _c(
                  "div",
                  { staticClass: "remark-item" },
                  [
                    _c("div", { staticClass: "remark-label" }, [
                      _vm._v(
                        _vm._s(_vm.$t("SystemMaintenance.CustomRemarkOne"))
                      )
                    ]),
                    _c("el-input", {
                      staticStyle: { width: "300px" },
                      attrs: {
                        type: "textarea",
                        maxlength: 200,
                        "show-word-limit": true,
                        rows: 4
                      },
                      model: {
                        value: _vm.customRemarkOne,
                        callback: function($$v) {
                          _vm.customRemarkOne = $$v
                        },
                        expression: "customRemarkOne"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "remark-item" },
                  [
                    _c("div", { staticClass: "remark-label" }, [
                      _vm._v(
                        _vm._s(_vm.$t("SystemMaintenance.CustomRemarkTwo"))
                      )
                    ]),
                    _c("el-input", {
                      staticStyle: { width: "300px" },
                      attrs: {
                        type: "textarea",
                        maxlength: 200,
                        "show-word-limit": true,
                        rows: 4
                      },
                      model: {
                        value: _vm.customRemarkTwo,
                        callback: function($$v) {
                          _vm.customRemarkTwo = $$v
                        },
                        expression: "customRemarkTwo"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-checkbox",
                  {
                    staticStyle: {
                      "margin-left": "8px",
                      "margin-right": "8px"
                    },
                    attrs: { no: "ifAutoUpdateRemark" },
                    model: {
                      value: _vm.ifAutoUpdateRemark,
                      callback: function($$v) {
                        _vm.ifAutoUpdateRemark = $$v
                      },
                      expression: "ifAutoUpdateRemark"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_AutoUpdateNote")))]
                )
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "triggers", attrs: { align: "center" } },
          [
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.saveConfig } },
              [_vm._v(" " + _vm._s(_vm.$t("common.btn.save")) + " ")]
            ),
            _c(
              "el-button",
              {
                staticStyle: { "margin-left": "30px" },
                attrs: { type: "primary" },
                on: { click: _vm.refreshConfig }
              },
              [_vm._v(" " + _vm._s(_vm.$t("common.btn.refresh")) + " ")]
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }